import { Injectable, Inject } from '@angular/core';
import { Meta, Title, MetaDefinition } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AppSettings } from '../settings/app.settings';

@Injectable()
export class SEOService {
    constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc, private router: Router) { }

    updateTitle(title: string) {
        this.title.setTitle(title);
    }

    updateDescription(desc: MetaDefinition) {
        this.meta.updateTag(desc);
    }
    getPageTitle() {
        return this.title.getTitle();
    }

    createLinkForCanonicalURL(url: string) {
        let canonical = url;
        // if empty we set canonical for itself
        if (!url || url === '') {
            canonical = this.router.url;
        }
        canonical = AppSettings.BASE_DOMAIN + canonical;
        const link = <HTMLLinkElement>this.doc.head.querySelector("link[rel='canonical']") || this.doc.head.appendChild(this.doc.createElement('link'));
        link.rel = 'canonical';
        link.href = canonical;
    }
}
